module.exports = __webpack_public_path__ + "img/slot_gamex_jili.113ae9cd.png";